module.exports = __webpack_public_path__ + "img/discover-no-user.5284eb23.png";